import { QueryObserverBaseResult, useQuery } from "react-query";
import api, { createURLParams } from "../../client";
import { queryKeys } from "../../query";
import { QueryParams } from "../../types/base";
import { UserListResponseData } from "../../types/user";

export const getData = async (params: QueryParams) => {
  const { data } = await api.get<UserListResponseData>(
    `/users${createURLParams(params)}`,
  );

  return data;
};

export const useUsers = (
  params: QueryParams,
  isAdmin: boolean,
): QueryObserverBaseResult<UserListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.userListPage(params),
    () => getData(params),
    { enabled: isAdmin },
  );
  return { data, ...props };
};
